module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_UAE.b7fc5e6a.txt";